module.exports = __webpack_public_path__ + "static/media/blc_logo.008f1610.svg";